import React, { useState } from "react";
import { Box, Button } from "@mui/material";

import TextInput from "../TextInput";
import QuestionDisplay from "./QuestionDisplay";

const TypeAnswer = ({ country, handleSubmitAnswer_Input, gameTitle }) => {
  const [inputValue, setInputValue] = useState("");

  const handleKeyDown = () => {
    document.getElementById("submitBtn").click();
  };

  return (
    <>
      {<QuestionDisplay gameTitle={gameTitle} country={country} />}
      <form style={{ width: "100%" }} onSubmit={(e) => e.preventDefault()}>
        <Box
          sx={{
            margin: "1rem auto",
            width: { xs: "90%", md: "70%", lg: "60%" },
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <TextInput
            setInputValue={setInputValue}
            inputValue={inputValue}
            handleKeyDown={handleKeyDown}
          />
          <Button
            id="submitBtn"
            variant="contained"
            size="small"
            type="submit"
            sx={{
              width: "25%",
              padding: "0.3rem",
            }}
            onClick={() => {
              if (inputValue.trim().length < 1) {
                return;
              }
              let inputBox = document.getElementById("inputBox");

              handleSubmitAnswer_Input(
                inputValue,
                country,
                inputBox,
                setInputValue
              );
            }}
          >
            Enter
          </Button>
        </Box>
      </form>
      <Button
        size="small"
        sx={{
          width: "25%",
          color: "gray",
          fontSize: "10px",
          margin: "0 auto 0.5rem auto",
        }}
        onClick={() => {
          let inputBox = document.getElementById("inputBox");
          handleSubmitAnswer_Input(
            inputValue,
            country,
            inputBox,
            setInputValue
          );
        }}
      >
        Skip
      </Button>
    </>
  );
};

export default TypeAnswer;
